"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var AcdcContext_1 = require("./AcdcContext");
var useBlurHandler_1 = require("./useBlurHandler");
function useAcdcPopupProps() {
    var _a = AcdcContext_1.useAcdcElementRegistryContext(), popupId = _a.popupId, setPopupElement = _a.setPopupElement, getInputElement = _a.getInputElement;
    var onBlur = useBlurHandler_1.usePopupBlurHandler();
    var onKeyDown = react_1.useCallback(function (e) {
        var inputElement = getInputElement();
        switch (e.key) {
            case 'ArrowDown':
            case 'ArrowUp':
                if (inputElement) {
                    inputElement.focus();
                }
                break;
            default:
        }
    }, [getInputElement]);
    return react_1.useMemo(function () { return [
        {
            id: popupId,
            role: 'listbox',
            ref: setPopupElement,
            tabIndex: -1,
            onBlur: onBlur,
            onKeyDown: onKeyDown,
        },
    ]; }, [setPopupElement]);
}
exports.default = useAcdcPopupProps;
